import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

let signalHubList = {};
export default {
  init: async function(hubName, host) {
    let url = `${window.location.origin}/${hubName}`;
    if (host) {
      url = `${host}/${hubName}`;
    }

    var hub = new HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(LogLevel.Information)
      .build();
    signalHubList[hubName] = hub;

    await hub.start();
    return hub;
  },
  stop: async function(hubName) {
    if (signalHubList.hasOwnProperty(hubName)) {
      await signalHubList[hubName].stop();
      delete signalHubList[hubName];
    }
  }
}